import React, { memo } from 'react'
import { NodeData } from '../../types'
import { useGraphRenderContext } from '../GraphRenderContext'
import CircleLeadersElement from './CircleLeadersElement'
import NodeElement from './NodeElement'

interface Props {
  node: NodeData
  selected?: boolean
  levelHidden?: boolean
  // Mount leaders avatars (computed at culling time, like members
  // visibility): prevents loading hundreds of images at once on page load
  showLeaders?: boolean
  // Rendered inside an EnterGroup wrapper (see NodeElement)
  inEnterGroup?: boolean
  // Temporarily hidden during a select-relayout animation (see NodeElement)
  hidden?: boolean
}

// Memoized: a culling pass only re-renders changed elements
export default memo(function CircleElement({
  node,
  selected,
  levelHidden,
  showLeaders = true,
  inEnterGroup,
  hidden,
}: Props) {
  const { events } = useGraphRenderContext()
  const { onCircleClick, onCircleContextMenu } = events

  // Pass parentId if this is an invited circle (id contains underscore)
  const parentId =
    node.data.id.indexOf('_') !== -1
      ? node.data.parentId ?? undefined
      : undefined

  return (
    <NodeElement
      node={node}
      selected={selected}
      levelHidden={levelHidden}
      inEnterGroup={inEnterGroup}
      hidden={hidden}
      onClick={
        onCircleClick
          ? () => {
              if (!node.data.entityId) return
              onCircleClick(node.data.entityId, parentId)
            }
          : undefined
      }
      onContextMenu={
        onCircleContextMenu
          ? (event) => {
              if (!node.data.entityId) return
              event.preventDefault()
              onCircleContextMenu(
                node.data.entityId,
                { x: event.clientX, y: event.clientY },
                parentId
              )
            }
          : undefined
      }
    >
      {node.data.participants && showLeaders && (
        <CircleLeadersElement node={node} />
      )}
    </NodeElement>
  )
})
